export default __webpack_public_path__ + "static/media/1849.684ce287.png";